import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import ForgetPassword from "../pages/ForgetPassword/";
import ResetPassword from "../pages/ResetPassword/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Subscription from "../pages/Subscription/";
import Kanban from "../pages/Kanban/";
import Campaigns from "../pages/Campaigns/";
import ChatFlows from "../pages/ChatFlows/";
import FlowBuilder from "../pages/FlowBuilder/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const PrivateRoutes = () => (
  <WhatsAppsProvider>
    <LoggedInLayout>
      <Switch>
        <Route exact path="/" component={Dashboard} isPrivate />
        <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
        <Route exact path="/connections" component={Connections} isPrivate />
        <Route exact path="/contacts" component={Contacts} isPrivate />
        <Route exact path="/campaigns" component={Campaigns} isPrivate />
        <Route exact path="/users" component={Users} isPrivate />
        <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
        <Route exact path="/settings" component={Settings} isPrivate />
        <Route exact path="/queues" component={Queues} isPrivate />
        <Route exact path="/subscription" component={Subscription} isPrivate />
        <Route exact path="/kanban" component={Kanban} isPrivate />
        <Route exact path="/chatflows" component={ChatFlows} isPrivate />
        <Route exact path="/flowbuilder/:id" component={FlowBuilder} isPrivate />
      </Switch>
    </LoggedInLayout>
  </WhatsAppsProvider>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/forget-password" component={ForgetPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route path="/" component={PrivateRoutes} isPrivate />
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
